<template>
  <div id="app">
    <JobOverviewPage v-if="currentPage == 'JobOverviewPage'"></JobOverviewPage>
    <JobPage v-if="currentPage == 'JobPage'"></JobPage>
  </div>
</template>

<script>
import JobOverviewPage from "./views/JobsOverviewPage.vue";
import JobPage from "./views/JobPage.vue";

export default {
  name: "app",
  components: {
    JobOverviewPage,
    JobPage,
  },
  computed: {
    currentPage: function () {
      if (!this.$store.state.loading) {
        let pathName = window.location.pathname;
        if (
          pathNameIncludesJobUrl(pathName, this.$store.state.miscData.CarUrls)
        ) {
          return "JobPage";
        } else {
          return "JobOverviewPage";
        }
      } else {
        // the spinner will be loaded on the JobOverViewPage if !dataReady
        return "JobOverviewPage";
      }
      // Compare the current Url(pathName) to the Urls of all jobs. This way we know if the current Url is the Url of a job.
      function pathNameIncludesJobUrl(pathName, jobUrls) {
        let pathNameIncludesJobUrl = false;
        for (let index = 0; index < jobUrls.length; index++) {
          let jobUrl = jobUrls[index];
          jobUrl = jobUrl.slice(0, -1); // remove trailing "/" because it might be missing and is not mandatory in the pathname;
          if (pathName.includes(jobUrl)) {
            pathNameIncludesJobUrl = true;
            break;
          } else {
            pathNameIncludesJobUrl = false;
          }
        }
        return pathNameIncludesJobUrl;
      }
    },
  },

  async beforeCreate() {
    var thisApp = this;

    // In the event a user navigates away from the application. The state is saved to localStorage.
    window.addEventListener("beforeunload", function (event) {
      localStorage.setItem(
        "automoduleState",
        JSON.stringify(thisApp.$store.state)
      );
    });

    howDidWeGetHere();
    loadFromServer(thisApp);
    // We load the state of the application depending on how the user got to the application.
    // loadFromServer() resets the application. (resets the filters)
    // loadSavedState() loads the saved state from localStorage. (remembers previously used filters)
    function howDidWeGetHere() {
      // // More info: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceNavigation/type
      // if (window.performance.navigation.type === 0) {
      //   // The page was accessed by following a link, a bookmark, a form submission, a script, or typing the URL in the address bar.
      //   loadFromServer(thisApp);
      // } else if (window.performance.navigation.type === 1) {
      //   // The page was accessed by clicking the Reload button or via the Location.reload() method.
      //   loadFromServer(thisApp);
      // } else if (window.performance.navigation.type === 2) {
      //   // The page was accessed by navigating into the history.
      //   loadFromServer(thisApp);
      // } else {
      //   loadFromServer(thisApp);
      // }
    }

    // load the state from localStorage. The filters the user previously used will still be set.
    // function loadSavedState(thisApp) {
    //   let localStorageState = JSON.parse(
    //     localStorage.getItem("automoduleState")
    //   );
    //   Object.assign(thisApp.$store.state, localStorageState);
    // }

    // load the state from the server (reset, new state). The filters the user previously used will be reset.
    async function loadFromServer(thisApp) {
      try {
        await thisApp.$store.dispatch("load");
      } catch (ex) {
        thisApp.error = "Failed to load data";
      } finally {
        thisApp.isBusy = false;
      }
    }
  },
};
</script>

<style>
b-img {
  display: block;
  width: 100%;
  height: auto;
}
#app {
  background-color: #f0efed;
  padding: 50px 0;
}
.column1 {
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.row1 {
  display: flex;
  flex-direction: row;
  justify-content: start;
}
</style>
